import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickMutation } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberAcademicDegree } from "./routeType";

const { key, getPath } = getApi("members.academicDegree.post");

type IExtractedRouteType =
  IMemberAcademicDegree["memberAcademicDegreeCollectionCreate"];

export type IPostMemberAcademicGroup = IPickMutation<IExtractedRouteType>;

const postMemberAcademicGroup: Fetcher<
  IPostMemberAcademicGroup["response"],
  IPostMemberAcademicGroup["variables"]
> = ({ memberId, ...data }) => {
  return axiosClient.post(getPath({ memberId }), data);
};

export const usePostMemberAcademicGroup = createQuery({
  queryKey: [key],
  fetcher: postMemberAcademicGroup,
});
